import type { ZudokuConfig } from 'zudoku';
import { createApiIdentityPlugin } from 'zudoku/plugins';
interface ApiIdentity {
  id: string;
  label: string;
  authorizeRequest: (request: Request) => Promise<Request> | Request;
}

interface ApiIdentityPlugin {
  getIdentities: () => Promise<ApiIdentity[]> | ApiIdentity[];
}

const config: ZudokuConfig = {
  authentication: {
    type: 'openid',
    clientId: 'varenergi-api-docs',
    issuer: 'https://varenergi.auth.chemcenter.no',
    scopes: ['openid', 'permissions'],
  },
  site: {
    logo: {
      src: {
        light: '/chem-center-logo.png',
        dark: '/chem-center-logo.png',
      },
      alt: 'ChemCenter',
      width: '200px',
    },
    title: 'API Documentation',
  },
  metadata: {
    description:
      'API documentation for ChemCenter, providing endpoints for managing ChemCenter data.',
    keywords: ['ChemCenter', 'API', 'Documentation', 'Safety Management'],
    authors: ['ChemCenter Team'],
  },

  navigation: [
    {
      type: 'category',
      label: 'Introduction',
      link: '/introduction',
      items: [
        {
          type: 'link',
          label: 'General information',
          to: '/introduction',
        },
        {
          type: 'category',
          label: 'Authentication',
          icon: 'lock',
          items: [
            'client-credentials-flow',
            'jwt-access-token-scope',
            'create-client-credentials',
          ],
        },
        {
          type: 'link',
          label: 'Environments',
          to: '/environments',
        },
      ],
    },
    {
      type: 'category',
      label: 'Inventory API Reference',
      items: [
        {
          type: 'category',
          label: 'Inventory API Reference',
          icon: 'sparkles',
          items: [
            {
              type: 'link',
              icon: 'folder-cog',
              badge: {
                label: 'New',
                color: 'purple',
              },
              label: 'API Reference',
              to: '/api/inventory',
            },
          ],
        },
      ],
    },
    {
      type: 'category',
      label: 'Approval API Reference',
      items: [
        {
          type: 'link',
          icon: 'folder-cog',
          badge: {
            label: 'New',
            color: 'purple',
          },
          label: 'API Reference',
          to: '/api/approval',
        },
      ],
    },
  ],
  redirects: [{ from: '/', to: '/introduction' }],
  apis: [
    {
      type: 'file',
      input: './apis/inventory.yaml',
      path: '/api/inventory',
    },
    {
      type: 'file',
      input: './apis/chemcenter.yaml',
      path: '/api/approval',
    },
  ],
  plugins: [
    createApiIdentityPlugin({
      getIdentities: async (context) => [
        {
          id: 'access-token',
          label: 'Current identity',
          authorizeRequest: async (request) => {
            let token = await context.authentication?.getAccessToken();
            if (token) {
              request.headers.set('Authorization', `Bearer ${token}`);
            }
            return request;
          },
        },
      ],
    }),
  ],
  protectedRoutes: {
    '/oauth/callback': () => true,
    '/*': ({ auth, context }) => !!auth?.isAuthenticated,
  },
};

export default config;
